import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-ink text-white relative overflow-hidden"
    >
      <div className="tr-container pt-24 md:pt-32 lg:pt-40 pb-14">
        <div className="grid grid-cols-12 gap-10">
          <div className="col-span-12 lg:col-span-8">
            <div className="overline text-vermilion mb-6">Let’s build together</div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight max-w-4xl">
              A partnership that ships,
              <br />
              <span className="italic text-white/70">not a vendor that slides.</span>
            </h2>
            <div className="mt-10 flex flex-wrap gap-4">
              <Link
                to="/contact"
                data-testid="footer-cta-partner"
                className="inline-flex items-center gap-2 bg-white text-ink px-7 py-4 text-[11px] uppercase tracking-[0.22em] font-semibold hover:bg-vermilion hover:text-white transition-colors"
              >
                Start a conversation <ArrowUpRight className="w-3.5 h-3.5" />
              </Link>
              <Link
                to="/careers"
                data-testid="footer-cta-careers"
                className="inline-flex items-center gap-2 border border-white/30 text-white px-7 py-4 text-[11px] uppercase tracking-[0.22em] font-semibold hover:border-white hover:bg-white/5 transition-colors"
              >
                Explore careers <ArrowUpRight className="w-3.5 h-3.5" />
              </Link>
            </div>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="overline text-white/50 mb-4">Studio</div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-nav-${l.label.toLowerCase()}`}
                    className="text-white/80 hover:text-white link-underline text-sm"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 lg:col-span-2">
            <div className="overline text-white/50 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li>
                <a
                  href="mailto:contact@thinkright-tech.com"
                  className="link-underline"
                  data-testid="footer-email"
                >
                  contact@thinkright-tech.com
                </a>
              </li>
              <li>Chandigarh · New York · Bengaluru</li>
              <li>Serving US · EU · IN</li>
              <li className="pt-3">
                <Link
                  to="/privacy"
                  className="text-white/60 hover:text-white link-underline text-xs"
                  data-testid="footer-privacy"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-24 pt-10 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-[22px] leading-none">ThinkRight</span>
            <span className="text-vermilion text-[22px] leading-none font-serif">.</span>
            <span className="overline text-white/60 ml-1">Tech</span>
          </div>
          <div className="text-xs text-white/50 tracking-wide">
            © {year} ThinkRight Tech — A Global Capability Center for cutting-edge product companies.
          </div>
        </div>
      </div>
    </footer>
  );
}
